import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/student/save_student_meal_settings
export const saveStudentMealSettings = async (
  studentAccountId: number,
  payload: Object
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/student/' + studentAccountId + '/save_student_meal_settings', payload)
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
